export const MAX_SCALE = 2.3
export const MIN_SCALE = 0.7
export const SCALE_MODIFIER = 0.2
export const DEFAULT_SCALE = 1.5
export const MARGIN_BETWEEN_PAGES = 32
export const PAGE_BORDER_WIDTH = 1
export const SELECTION_BOX_PADDING = 4
export const COMMENT_REGION_WIDTH = 350
export const MARGIN_BETWEEN_COMMENT_GROUPS = 12
export const PREVIOUS_COMMENTS_BUTTON_HEIGHT = 18
export const MORE_COMMENTS_BUTTON_HEIGHT = 32
export const DEFAULT_LINE_WIDTH = 1
export const SELECTED_LINE_WIDTH = 2

// TODO: align this with AnnotationKind
export const ANNOTATION_TYPES = ['ink', 'area', 'point', 'highlight', 'strikeout', 'freetext']

export const ANNOTATION_TYPES_WITH_AUTO_EXPANDED_COMMENT = ['text', 'square']

export const MAIN_COLORS = {
  Red: '#EE0612',
  Orange: '#FC5E13',
  Yellow: '#FCB900',
  Brown: '#8D6437',
  Green: '#00AC18',
  'Dark Blue': '#234C9F',
  Blue: '#008EE2',
  Pink: '#C31FA8',
  Purple: '#741865',
  'Dark Gray': '#363636',
}

export const POINT_COLORS = MAIN_COLORS
export const DEFAULT_POINT_ANNOTATION_COLOR = POINT_COLORS['Blue']

export const INK_COLORS = MAIN_COLORS
export const DEFAULT_INK_ANNOTATION_COLOR = INK_COLORS['Blue']

export const STRIKEOUT_COLORS = MAIN_COLORS
export const DEFAULT_STRIKEOUT_ANNOTATION_COLOR = INK_COLORS['Red']

export const AREA_COLORS = MAIN_COLORS
export const DEFAULT_AREA_ANNOTATION_COLOR = AREA_COLORS['Blue']

export const FREETEXT_COLORS = MAIN_COLORS
export const DEFAULT_FREETEXT_ANNOTATION_COLOR = FREETEXT_COLORS['Dark Gray']

export const FREETEXT_BACKGROUND_COLORS = {
  White: '#FFFFFF',
  None: 'transparent',
}

export const DEFAULT_FREETEXT_BACKGROUND_COLOR = FREETEXT_BACKGROUND_COLORS['None']

export const HIGHLIGHT_COLORS = {
  Red: '#FF9999',
  Orange: '#FFC166',
  Yellow: '#FCE680',
  Green: '#99EBA4',
  Blue: '#80D0FF',
  Pink: '#FFB9F1',
}
export const DEFAULT_HIGHLIGHT_ANNOTATION_COLOR = HIGHLIGHT_COLORS['Yellow']

export const FRIENDLY_COLORS = {
  '#EE0612': 'Red',
  '#FF9999': 'Red', // highlight version
  '#FF0000': 'Red', // crocodoc version
  '#A90101': 'Red', // crocodoc point version
  '#FC5E13': 'Orange',
  '#FFC166': 'Orange', // highlight version
  '#FCCC6A': 'Orange', // crocodoc highlight version
  '#FCB900': 'Yellow',
  '#FCE680': 'Yellow', // highlight version
  '#FFF688': 'Yellow', // crocodoc highlight version
  '#8D6437': 'Brown',
  '#00AC18': 'Green',
  '#99EBA4': 'Green', // highlight version
  '#BFF694': 'Green', // crocodoc highlight version
  '#00AA00': 'Green', // crocodoc version
  '#234C9F': 'Dark Blue',
  '#008EE2': 'Blue',
  '#80D0FF': 'Blue', // highlight version
  '#98DDFF': 'Blue', // crocodoc highlight version
  '#0000FF': 'Blue', // crocodoc version
  '#C31FA8': 'Pink',
  '#FFB9F1': 'Pink', // highlight version
  '#741865': 'Purple',
  '#363636': 'Dark Gray',
  '#000000': 'Dark Gray', // crocodoc version
  '#FFFFFF': 'White',
  transparent: 'None',
}

// these individual imports are necessary for separate webpack bundles
export const AVAILABLE_LOCALES = {
  ar: () => import(/* webpackChunkName: "ar" */ '../translations/docviewer_ar.json'),
  cy: () => import(/* webpackChunkName: "cy" */ '../translations/docviewer_cy.json'),
  da: () => import(/* webpackChunkName: "da" */ '../translations/docviewer_da.json'),
  de: () => import(/* webpackChunkName: "de" */ '../translations/docviewer_de.json'),
  'en-au': () => import(/* webpackChunkName: "en_AU" */ '../translations/docviewer_en_AU.json'),
  'en-gb': () => import(/* webpackChunkName: "en_GB" */ '../translations/docviewer_en_GB.json'),
  en: () => import(/* webpackChunkName: "en" */ '../translations/docviewer_en.json'),
  es: () => import(/* webpackChunkName: "es" */ '../translations/docviewer_es.json'),
  'es-es': () => import(/* webpackChunkName: "es_ES" */ '../translations/docviewer_es_ES.json'),
  'fr-ca': () => import(/* webpackChunkName: "fr_CA" */ '../translations/docviewer_fr_CA.json'),
  fr: () => import(/* webpackChunkName: "fr" */ '../translations/docviewer_fr.json'),
  ht: () => import(/* webpackChunkName: "ht" */ '../translations/docviewer_ht.json'),
  is: () => import(/* webpackChunkName: "is" */ '../translations/docviewer_is.json'),
  it: () => import(/* webpackChunkName: "it" */ '../translations/docviewer_it.json'),
  ja: () => import(/* webpackChunkName: "ja" */ '../translations/docviewer_ja.json'),
  mi: () => import(/* webpackChunkName: "mi" */ '../translations/docviewer_mi.json'),
  'nb-no': () => import(/* webpackChunkName: "nb" */ '../translations/docviewer_nb.json'),
  nb: () => import(/* webpackChunkName: "nb" */ '../translations/docviewer_nb.json'),
  nl: () => import(/* webpackChunkName: "nl" */ '../translations/docviewer_nl.json'),
  pl: () => import(/* webpackChunkName: "pl" */ '../translations/docviewer_pl.json'),
  'pt-br': () => import(/* webpackChunkName: "pt_BR" */ '../translations/docviewer_pt_BR.json'),
  pt: () => import(/* webpackChunkName: "pt" */ '../translations/docviewer_pt.json'),
  ru: () => import(/* webpackChunkName: "ru" */ '../translations/docviewer_ru.json'),
  sv: () => import(/* webpackChunkName: "sv" */ '../translations/docviewer_sv.json'),
  th: () => import(/* webpackChunkName: "th" */ '../translations/docviewer_th.json'),
  vi: () => import(/* webpackChunkName: "vi" */ '../translations/docviewer_vi.json'),
  'zh-hant': () => import(/* webpackChunkName: "zh_HK" */ '../translations/docviewer_zh_HK.json'),
  'zh-hans': () => import(/* webpackChunkName: "zh" */ '../translations/docviewer_zh.json'),
  'zh-hk': () => import(/* webpackChunkName: "zh_HK" */ '../translations/docviewer_zh_HK.json'),
  zh: () => import(/* webpackChunkName: "zh" */ '../translations/docviewer_zh.json'),
}

export const FONTS_BY_SIZE = {
  Small: '14pt Verdana',
  Medium: '22pt Verdana',
  Large: '38pt Verdana',
}

export const DEFAULT_FONT = FONTS_BY_SIZE['Small']

export const INK_STROKE_WIDTH_OPTIONS = {
  Small: 1,
  Medium: 4,
  Large: 8,
}

export const DEFAULT_INK_STROKE_WIDTH = INK_STROKE_WIDTH_OPTIONS['Small']

// This value references the top and bottom margin of Page.css .Page
export const DEFAULT_PAGES_CONTAINER_MARGIN_OFFSET = 100

export const COMMENT_LINE_TOP_OFFSET = 6

export const STACKED_COMMENT_GROUP = 'Stacked Comment Group'

export const UNSTACKED_COMMENT_GROUP = 'Unstacked Comment Group'

export const MINIMAL_PREDICTED_COMMENT_WITH_REPLIES_HEIGHT = 98

export const PEN_POINTER_TYPE = 'pen'

export const TOUCH_POINTER_TYPE = 'touch'

// https://developer.mozilla.org/en-US/docs/Web/API/Pointer_events#Determining_button_states
export const PEN_ACTION_BUTTON_STATE = 2

export const ANNOTATION_TAP_THRESHOLD = 3
